import React, { useState, useEffect, useRef } from 'react';
import logo from '/imageAssets/pfizer-logo-color.png';
import Cookies from 'js-cookie';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState(['', '', '', '']);
  const [error, setError] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPinComplete, setIsPinComplete] = useState(false);
  const pinInputs = [useRef(), useRef(), useRef(), useRef()];

  useEffect(() => {
    localStorage.removeItem('isLoggedIn');
  }, []);

  const validateEmail = (email) => {
    const regex = /@pfizer\.com$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setIsEmailValid(validateEmail(newEmail));
  };

  const handlePinChange = (index, value) => {
    if (value.length <= 1) {
      const newPin = [...pin];
      newPin[index] = value;
      setPin(newPin);

      if (value !== '' && index < 3) {
        pinInputs[index + 1].current.focus();
      }

      setIsPinComplete(newPin.every(digit => digit !== ''));
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && pin[index] === '' && index > 0) {
      pinInputs[index - 1].current.focus();
    }
  };

  const logLoginAction = async (email) => {
    const apiUrl = `https://vwt-api.pfizer-qr.com/api/?e=${encodeURIComponent(email)}&c=website&a=click&l=login&v=open`;
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      console.log('Login action logged successfully');
    } catch (error) {
      console.error('Error logging login action:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const enteredPin = pin.join('');
    if (validateEmail(email) && enteredPin === '2024') {
      try {
        await logLoginAction(email);
        Cookies.set('userEmail', email, { expires: 7 }); // Set cookie to expire in 7 days
        onLogin();
      } catch (error) {
        console.error('Error during login:', error);
        setError('An error occurred during login. Please try again.');
      }
    } else {
      setError('Invalid email or PIN');
    }
  };

  const isLoginEnabled = isEmailValid && isPinComplete;

  return (
    <div className="login-container">
      <img src={logo} alt="Logo" className="login-logo"/>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-header">
          <h2 className='diatype-light'>Please Login</h2>
          <p>Welcome to Pfizer's Virtual World</p>
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={handleEmailChange}
            required
            placeholder='example@pfizer.com'
            style={{ 
              padding: '1rem',
              width: '89%'
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="pin">PIN:</label>
          <div className="pin-input-container">
            {pin.map((digit, index) => (
              <input
                key={index}
                type="password"
                placeholder='•'
                maxLength="1"
                value={digit}
                onChange={(e) => handlePinChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                ref={pinInputs[index]}
                required
              />
            ))}
          </div>
        </div>
        {error && <p className="error-message">{error}</p>}
        <button 
          type="submit" 
          className={`login-button ${!isLoginEnabled ? 'disabled' : ''}`}
          disabled={!isLoginEnabled}
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default Login;